var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.5C7.19891 0.5 7.38968 0.579018 7.53033 0.71967C7.67098 0.860322 7.75 1.05109 7.75 1.25V18.9395L12.469 14.219C12.6098 14.0782 12.8008 13.9991 13 13.9991C13.1992 13.9991 13.3902 14.0782 13.531 14.219C13.6718 14.3598 13.7509 14.5508 13.7509 14.75C13.7509 14.9492 13.6718 15.1402 13.531 15.281L7.531 21.281C7.46133 21.3508 7.37857 21.4063 7.28745 21.4441C7.19633 21.4819 7.09865 21.5013 7 21.5013C6.90135 21.5013 6.80367 21.4819 6.71255 21.4441C6.62143 21.4063 6.53867 21.3508 6.469 21.281L0.469001 15.281C0.328171 15.1402 0.249054 14.9492 0.249054 14.75C0.249054 14.5508 0.328171 14.3598 0.469001 14.219C0.609831 14.0782 0.800838 13.9991 1 13.9991C1.19916 13.9991 1.39017 14.0782 1.531 14.219L6.25 18.9395V1.25C6.25 1.05109 6.32902 0.860322 6.46967 0.71967C6.61032 0.579018 6.80109 0.5 7 0.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).9a55792395723a05d0ec99fadf05eab7.svg";
export { ForwardRef as ReactComponent };